(() => {
  const SECTION_SELECTOR = '.oddit-section-popup';
  const STORAGE_KEY = 'oddit-age-verified';
  const VERIFIED_MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  function isVerified() {
    try {
      const verifiedAt = Number(localStorage.getItem(STORAGE_KEY));
      return verifiedAt > 0 && Date.now() - verifiedAt < VERIFIED_MAX_AGE;
    } catch (e) {
      return false;
    }
  }

  function rememberVerified() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
    document.documentElement.classList.add('oddit-age-verified');
  }

  function releaseEmailPopup(section) {
    const delay = Number(section.dataset.emailPopupDelay) || 0;
    setTimeout(() => {
      document.documentElement.classList.remove('oddit-age-gate-open');
    }, delay * 1000);
  }

  function initSection(section) {
    const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (!inDesignMode && isVerified()) {
      document.documentElement.classList.add('oddit-age-verified');
      document.documentElement.classList.remove('oddit-age-gate-open');
      section.style.display = 'none';
      return;
    }

    const inputs = section.querySelectorAll('.oddit-section-popup__input');
    const button = section.querySelector('.oddit-section-popup__button');

    for (const input of inputs) {
      input.addEventListener('input', handleInput);
      input.addEventListener('input', () => hideError(section));
      input.addEventListener('keydown', handleKeydown);
    }

    if (button) {
      button.addEventListener('click', () => handleSubmit(section));
    }

    const yesButton = section.querySelector('[data-popup-yes]');
    const noButton = section.querySelector('[data-popup-no]');

    if (yesButton) {
      yesButton.addEventListener('click', () => grantAccess(section));
    }

    if (noButton) {
      noButton.addEventListener('click', () => setError(section, true));
    }

    // In the theme editor the popup stays hidden (and the page scrollable)
    // until its own section is selected - see the editor events below.
    if (!inDesignMode) {
      document.body.style.overflow = 'hidden';
    }
  }

  function setEditorVisible(section, visible) {
    section.classList.toggle('oddit-section-popup--editor-hidden', !visible);
  }

  function grantAccess(section) {
    rememberVerified();
    section.style.display = 'none';
    document.body.style.overflow = '';
    releaseEmailPopup(section);
  }

  function handleInput(e) {
    const input = e.target;
    const value = input.value.replace(/\D/g, '');
    input.value = value;

    const max = Number(input.maxLength);
    if (value.length >= max) {
      const fields = input.closest('.oddit-section-popup__fields');
      if (!fields) return;
      const inputs = [...fields.querySelectorAll('.oddit-section-popup__input')];
      const idx = inputs.indexOf(input);
      if (idx < inputs.length - 1) {
        inputs[idx + 1].focus();
      }
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Backspace' && e.target.value === '') {
      const fields = e.target.closest('.oddit-section-popup__fields');
      if (!fields) return;
      const inputs = [...fields.querySelectorAll('.oddit-section-popup__input')];
      const idx = inputs.indexOf(e.target);
      if (idx > 0) {
        inputs[idx - 1].focus();
      }
    }
  }

  function setError(section, visible) {
    const error = section.querySelector('[data-popup-error]');
    if (error) error.hidden = !visible;
  }

  function hideError(section) {
    setError(section, false);
  }

  function handleSubmit(section) {
    const inputs = section.querySelectorAll('.oddit-section-popup__input');
    const [mm, dd, yyyy] = [...inputs].map(i => i.value);

    if (!mm || !dd || !yyyy || yyyy.length < 4) return;

    const birthDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    const minimumAge = Number(section.dataset.minimumAge) || 21;
    if (age >= minimumAge) {
      grantAccess(section);
    } else {
      setError(section, true);
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // A reload means the merchant is editing the popup's settings, so keep it
  // in view; otherwise show it only while its section is selected.
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (!section) return;
    initSection(section);
    setEditorVisible(section, true);
  });

  document.addEventListener('shopify:section:select', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) setEditorVisible(section, true);
  });

  document.addEventListener('shopify:section:deselect', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) setEditorVisible(section, false);
  });
})();